<template>
  <div class="voting-process__wrapper">
    <h2 class="voting-process__title title-new uppercase">
      AWARDS PROCESS:
      <br />
      FROM NOMINATION TO CELEBRATION
    </h2>

    <p class="voting-process__subtitle text-body">
      The Finance Magnates Annual Awards celebrate excellence and innovation
      within the financial sector. Our awards process is designed to be
      transparent, democratic, and inclusive, across three key stages.
    </p>

    <ul class="voting-process-stages__wrapper">
      <li
        v-for="(stageItem, index) in stages"
        :key="stageItem.stage"
        class="voting-process-stages__stage-container"
      >
        <div class="voting-process-stages__stage">
          <div class="voting-process-stages__stage-header">
            <div
              class="voting-process-stages__stage-header-title-date-description"
            >
              <div class="voting-process-stages__stage-header-index-title-date">
                <div
                  class="voting-process-stages__stage-header-index subtitle-1"
                >
                  {{ getStagePosition(index) }}
                </div>
                <div class="voting-process-stages__stage-header-title-date">
                  <div
                    class="voting-process-stages__stage-header-title-wrapper"
                  >
                    <h3
                      class="voting-process-stages__stage-header-title subtitle-1"
                    >
                      {{ stageItem.title }}
                    </h3>
                  </div>
                  <div
                    class="voting-process-stages__stage-header-date text-caption"
                    v-html="stageItem.date"
                  />
                </div>
              </div>

              <div
                class="voting-process-stages__stage-description text-caption"
                v-html="stageItem.description"
              />
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'VotingProcessSection',
  data() {
    return {
      stages: [
        {
          title: 'NOMINATE',
          description:
            '<p>Open call for nominations during March - September 2026, inviting industry professionals, peers, and companies to propose brands that exemplify leadership, innovation, and impact in their respective fields.</p>' +
            '<p><em>Voting closed on October 16th</em></p>',
          date: 'March<br>September'
        },
        {
          title: 'VOTE',
          description:
            "<p><b>Community Voting:</b> 50% of voting power is held by the industry. Through our Finance Magnates channels, industry professionals can cast their votes for the B2B categories. Similarly, members of the global trading community can participate in voting for the B2C categories via our ForexLive channels. This ensures that our community's perspective plays a crucial role in the decision-making process.</p>" +
            '<p><b>Expert Panel:</b> The remaining 50% of the vote comes from an esteemed panel of judges, comprised of top industry experts from notable entities. These experts bring a depth of knowledge and industry experience to the table, providing a balanced and comprehensive assessment of the nominees.</p>' +
            '<p class="semi-bold"><em>Each brand will only  be recognised in the Award Category in which they receive the most votes.</em></p>' +
            '<p class="semi-bold"><em>Voting closed on October 16th</em></p>',
          date: 'September<br>October'
        },
        {
          title: 'CELEBRATE',
          description:
            '<p>Winners will be revealed during a glamorous Gala Dinner held in Limassol, Cyprus on the <b>6th of November 2026</b>. This celebratory evening includes physical trophies.</p>',
          date: 'November'
        }
      ]
    }
  },
  methods: {
    getStagePosition(index) {
      return (index + 1).toString().padStart(2, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
.voting-process__wrapper {
  $padding-top: (
    $above-desktop-xl: 50px,
    $tablet: 59px,
    $mobile: 32px
  );

  @include setStyleByBreakpoint('padding-top', $padding-top);

  .voting-process__subtitle {
    $margin: (
      $above-desktop-xl: 10px 0 70px,
      $tablet: 19px 0 120px,
      $mobile: 24px 0 50px
    );

    @include setStyleByBreakpoint('margin', $margin);
  }

  .voting-process-stages__wrapper {
    display: flex;
    flex-direction: column;

    $margin-bottom: (
      $above-desktop-xl: 64px,
      $mobile: 32px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);

    .voting-process-stages__stage-container {
      $margin-bottom: (
        $above-desktop-xl: 96px,
        $mobile: 64px
      );

      @include setStyleByBreakpoint('margin-bottom', $margin-bottom);

      &:last-child {
        margin-bottom: 0;
      }

      .voting-process-stages__stage {
        $padding-x: (
          $above-desktop-xl: 24px,
          $mobile: 16px
        );

        @include setStyleByBreakpoint('padding-left', $padding-x);
        @include setStyleByBreakpoint('padding-right', $padding-x);
      }

      .voting-process-stages__stage-header {
        position: relative;
        display: flex;

        .voting-process-stages__stage-header-index {
          flex-shrink: 0;
          font-weight: 400;

          @include mobile {
            margin-bottom: 16px;
          }
        }

        .voting-process-stages__stage-header-title-date-description {
          flex-grow: 1;
        }

        .voting-process-stages__stage-header-index-title-date {
          display: flex;
        }

        .voting-process-stages__stage-header-title-date {
          display: flex;
          justify-content: space-between;
          flex-grow: 1;
        }

        .voting-process-stages__stage-header-title-wrapper {
          max-width: 958px;
          display: flex;
          flex-direction: column;

          $margin-left: (
            $above-desktop-xl: 24px,
            $mobile: 0
          );

          $margin-right: (
            $above-desktop-xl: 32px,
            $mobile: 16px
          );

          @include setStyleByBreakpoint('margin-left', $margin-left);
          @include setStyleByBreakpoint('margin-right', $margin-right);
        }

        .voting-process-stages__stage-header-title {
          word-break: keep-all;
          letter-spacing: 1px;

          $font-size: (
            $tablet: 24px,
            $mobile: 20px
          );

          $line-height: (
            $tablet: 44px,
            $mobile: 30px
          );

          $margin-left: (
            $above-desktop-xl: 0,
            $mobile: 16px
          );

          @include setStyleByBreakpoint('line-height', $line-height);
          @include setStyleByBreakpoint('font-size', $font-size);
          @include setStyleByBreakpoint('margin-left', $margin-left);
        }

        .voting-process-stages__stage-header-date {
          margin-left: auto;
          color: $c--gray-light;
          flex-shrink: 0;

          $margin-top: (
            $above-desktop-xl: 8px,
            $tablet: 12px,
            $mobile: 0
          );

          @include setStyleByBreakpoint('margin-top', $margin-top);

          @include mobile {
            position: absolute;
            right: -8px;
          }
        }
      }

      .voting-process-stages__stage-description {
        color: $c--gray-light;

        $margin: (
          $above-desktop-xl: 14px 108px 0 64px,
          $tablet: 10px 108px 0 64px,
          $mobile: 32px 0 0 0
        );

        @include setStyleByBreakpoint('margin', $margin);

        /deep/ > p {
          margin-bottom: 18px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
